<template>
	<CModal
		:title="title"
		:show.sync="exportModal"
		centered
		fade
		class="disable-footer disable-header"
		:closeOnBackdrop="false"
	>
		<div class="popup-header">
			<h5 class="modal-title">{{ title }}</h5>
			<button type="button" @click="handleClose">
				<CIcon name="cil-x" />
			</button>
		</div>
		<br />
		<CSelect
			label="File Extension"
			placeholder="Select an extension"
			:options="extensionOptions"
			horizontal
			:value.sync="selectedExtension"
			id="select"
		/>

		<h6 v-if="exportRequestRaised">
			Export request is sent to server. We will notify you once the link to
			download the file is ready.
		</h6>

		<div class="inactive-modal-response">
			<template v-if="!exportRequestRaised">
				<CButton
					:disabled="!selectedExtension"
					type="submit"
					color="primary"
					class="m-1 float-right"
					@click="handleExport"
					>Export</CButton
				>
				<CButton
					type="submit"
					color="secondary"
					class="m-1 float-right"
					@click="handleClose"
					>Cancel</CButton
				>
			</template>
			<template v-else>
				<CButton
					type="submit"
					color="secondary"
					class="m-1 float-right"
					@click="handleClose"
					>Okay</CButton
				>
			</template>
		</div>
	</CModal>
</template>

<script>
import { storeData } from "../../store";
import gql from "graphql-tag";

const FILE_EXPORT_STATUS = gql`
	mutation (
		$file_name: String!
		$type: String!
		$client_id: uuid
		$file_extension: String!
		$comparison_data: jsonb
	) {
		insert_spendmd_db_file_export_status(
			objects: {
				file_name: $file_name
				type: $type
				client_id: $client_id
				file_extension: $file_extension
				comparison_data: $comparison_data
			}
		) {
			returning {
				id
			}
		}
	}
`;

export default {
	props: {
		modal: Boolean,
		title: String,
		type: String,
		comparisonData: Array,
	},
	data() {
		return {
			exportModal: false,
			selectedExtension: null,
			exportRequestRaised: false,
			selectedClient: null,
		};
	},
	computed: {
		extensionOptions() {
			return [
				{ text: "CSV", value: "csv" },
				{ text: "XLSX", value: "xlsx" },
			];
		},
	},
	watch: {
		modal() {
			this.exportModal = this.modal;
		},
	},
	methods: {
		handleClose() {
			this.exportModal = false;
			this.reset();
			this.$emit("close");
		},
		handleExport() {
			this.$apollo
				.mutate({
					mutation: FILE_EXPORT_STATUS,
					variables: {
						file_name: `${this.type}-${+new Date()}`,
						type: this.type,
						client_id: this.selectedClient,
						file_extension: this.selectedExtension,
						comparison_data: this.comparisonData || [],
					},
				})
				.then((res) => {
					const result =
						res.data.insert_spendmd_db_file_export_status.returning[0];
					if (result.id > 0) {
						this.exportRequestRaised = true;
					}
				})
				.catch((err) => {
					console.log(err);
				});
		},
		reset() {
			if (document.getElementById("select"))
				document.getElementById("select").selectedIndex = 0;
			this.exportRequestRaised = false;
		},
	},
	async beforeMount() {
		this.exportModal = false;
		this.reset();

		if (
			storeData.currentUserDetails.role.name === "client_admin" ||
			storeData.currentUserDetails.role.name === "client_user"
		) {
			this.selectedClient = storeData.currentUserDetails.client_id;
		}
	},
};
</script>

<style>
.custom-col {
	padding-left: 10px;
	padding-top: 0px;
}
.custom-col1 {
	padding-left: 10px;
	padding-top: 15px;
	padding-bottom: 5px;
}
</style>